<template>
  <!-- eslint-disable max-len -->
  <info>
    <h1>{{ $t("ABOUT_APPDB") }}</h1>
    <div v-html="$t('ABOUT_APPDB_DESC')"></div>

    <template slot="sidebar">
      <template v-if="BRAND_KEY === 'appdb'">
        <h2>{{ $t("STAY TUNED") }}</h2>
        <html-with-links
          tag="p"
          :html="
            $t('APPDB_SOCIAL', {
              twitterLink: 'https://twitter.com/appdb_official',
              telegramLink: 'https://t.me/appdb_telegram',
              redditLink: 'https://www.reddit.com/r/appdb',
              storyLink: '/info/empire-strikes-back',
            })
          "
        ></html-with-links>
      </template>
    </template>
  </info>
</template>

<script>
import Info from '@/components/Info';
import HtmlWithLinks from '@/components/HtmlWithLinks';

export default {
  components: { Info, HtmlWithLinks },
  computed: {
    title() {
      return `About ${this.BRAND_CONFIG.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
p::v-deep {
  br {
    display: none;
  }

  br + p {
    margin-top: 7px;
  }
}
</style>
